import { IconProp } from '@fortawesome/fontawesome-svg-core'

import { KeyValuePair, ReactFunctionalComponent, ValueHash } from '@unreserved-frontend-v2/utils/types'

export enum FilterType {
  External,
  Search,
  Select,
  ValueList,
  HorizontalPicker,
  ToggleButtonGroup,
  Sort,
  SelectRanged,
  Spacer,
}

export interface FilterChangeEvent {
  key: string
  value: unknown
  context?: ValueHash<unknown>
}

export type FilterValueSelect = { key: string; values: KeyValuePair<string | number>[]; suffixRemovalStr?: string }
export type FilterValue = KeyValuePair<string>

export type FilterValues = ValueHash<FilterValue[] | FilterValueSelect[]>
export type FilterSelections = ValueHash<unknown>

export type FilterValueHorizontalPicker = Filter & {
  href?: string
  rel?: string
  count?: number
  className?: string
  subKey?: string
}

export interface Filter {
  key: string
  type: FilterType
  placeholder?: string
  icon?: IconProp
  classes?: string
  label?: string
  headerLabel?: string
  step?: number
  inputIcon?: IconProp
  inputFixedRightText?: string
  externalComponentType?: ReactFunctionalComponent
  externalComponentProps?: Record<string, unknown>
  tileGrid?: boolean
  value?: string | number | boolean
  isCappedWrapper?: boolean
  sxValues?: ValueHash<string | ValueHash<string>>
}

export interface FilterStatus {
  key: string
  value: string
}

export interface ColumnHeading {
  key: string
  classes?: string
}

export enum PageDirection {
  Previous,
  Next,
}
